export const version_data =  {
  version_number: "1.0.2",
  edit_time: "2024/11/14",
  editor_code: "2366"
}
